/**
 * @license
 * Visual Blocks Editor
 *
 * Copyright 2016 Massachusetts Institute of Technology
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import * as Blockly from 'blockly/core';

/**
 * Block to say for some time.
 */
Blockly.Blocks['looks_sayforsecs'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SAYFORSECS,
      args0: [
        {
          type: 'input_value',
          name: 'MESSAGE'
        },
        {
          type: 'input_value',
          name: 'SECS'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to say.
 */
Blockly.Blocks['looks_say'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SAY,
      args0: [
        {
          type: 'input_value',
          name: 'MESSAGE'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to think for some time.
 */
Blockly.Blocks['looks_thinkforsecs'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_THINKFORSECS,
      args0: [
        {
          type: 'input_value',
          name: 'MESSAGE'
        },
        {
          type: 'input_value',
          name: 'SECS'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to think.
 */
Blockly.Blocks['looks_think'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_THINK,
      args0: [
        {
          type: 'input_value',
          name: 'MESSAGE'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to show.
 */
Blockly.Blocks['looks_show'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SHOW,
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to hide.
 */
Blockly.Blocks['looks_hide'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_HIDE,
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Hide-all-sprites block. Does not actually do anything. This is an
 * obsolete block that is implemented for compatibility with Scratch 2.0
 * projects.
 */
Blockly.Blocks['looks_hideallsprites'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_HIDEALLSPRITES,
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to change graphic effect.
 */
Blockly.Blocks['looks_changeeffectby'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_CHANGEEFFECTBY,
      args0: [
        {
          type: 'field_dropdown',
          name: 'EFFECT',
          options: [
            [Blockly.Msg.LOOKS_EFFECT_COLOR, 'COLOR'],
            [Blockly.Msg.LOOKS_EFFECT_FISHEYE, 'FISHEYE'],
            [Blockly.Msg.LOOKS_EFFECT_WHIRL, 'WHIRL'],
            [Blockly.Msg.LOOKS_EFFECT_PIXELATE, 'PIXELATE'],
            [Blockly.Msg.LOOKS_EFFECT_MOSAIC, 'MOSAIC'],
            [Blockly.Msg.LOOKS_EFFECT_BRIGHTNESS, 'BRIGHTNESS'],
            [Blockly.Msg.LOOKS_EFFECT_GHOST, 'GHOST']
          ]
        },
        {
          type: 'input_value',
          name: 'CHANGE'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to set graphic effect.
 */
Blockly.Blocks['looks_seteffectto'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SETEFFECTTO,
      args0: [
        {
          type: 'field_dropdown',
          name: 'EFFECT',
          options: [
            [Blockly.Msg.LOOKS_EFFECT_COLOR, 'COLOR'],
            [Blockly.Msg.LOOKS_EFFECT_FISHEYE, 'FISHEYE'],
            [Blockly.Msg.LOOKS_EFFECT_WHIRL, 'WHIRL'],
            [Blockly.Msg.LOOKS_EFFECT_PIXELATE, 'PIXELATE'],
            [Blockly.Msg.LOOKS_EFFECT_MOSAIC, 'MOSAIC'],
            [Blockly.Msg.LOOKS_EFFECT_BRIGHTNESS, 'BRIGHTNESS'],
            [Blockly.Msg.LOOKS_EFFECT_GHOST, 'GHOST']
          ]
        },
        {
          type: 'input_value',
          name: 'VALUE'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to clear graphic effects.
 */
Blockly.Blocks['looks_cleargraphiceffects'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_CLEARGRAPHICEFFECTS,
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to change size.
 */
Blockly.Blocks['looks_changesizeby'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_CHANGESIZEBY,
      args0: [
        {
          type: 'input_value',
          name: 'CHANGE'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to set size.
 */
Blockly.Blocks['looks_setsizeto'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SETSIZETO,
      args0: [
        {
          type: 'input_value',
          name: 'SIZE'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to report size.
 */
Blockly.Blocks['looks_size'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SIZE,
      extensions: ['colours_looks', 'output_number', 'monitor_block']
    });
  }
};

/**
 * Block to change stretch. Does not actually do anything. This is an
 * obsolete block that is implemented for compatibility with Scratch 1.4
 * projects as well as 2.0 projects that still have the block.
 * The 'stretch' blocks were introduced in very early versions of Scratch,
 * but their functionality was removed shortly later. They still appeared
 * correctly up until (and including) Scratch 1.4 - as 'change stretch by'
 * and 'set stretch to' - but were removed altogether in Scratch 2.0, and
 * displayed as red 'undefined' blocks. Some Scratch projects still contain
 * these blocks, however, and they don't open in 3.0 unless the blocks
 * actually exist (though they still don't functionally do anything).
 */
Blockly.Blocks['looks_changestretchby'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_CHANGESTRETCHBY,
      args0: [
        {
          type: 'input_value',
          name: 'CHANGE'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to set stretch. Does not actually do anything. This is an obsolete
 * block that is implemented for compatibility with Scratch 1.4 projects
 * (see looks_changestretchby).
 */
Blockly.Blocks['looks_setstretchto'] = {
  init: function() {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SETSTRETCHTO,
      args0: [
        {
          type: 'input_value',
          name: 'STRETCH'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Costumes drop-down menu.
 */
Blockly.Blocks['looks_costume'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: '%1',
      args0: [
        {
          type: 'field_dropdown',
          name: 'COSTUME',
          options: [
            ['costume1', 'COSTUME1'],
            ['costume2', 'COSTUME2']
          ]
        }
      ],
      extensions: ['colours_looks', 'output_string']
    });
  }
};

/**
 * Block to switch the sprite's costume to the selected one.
 */
Blockly.Blocks['looks_switchcostumeto'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SWITCHCOSTUMETO,
      args0: [
        {
          type: 'input_value',
          name: 'COSTUME'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to switch the sprite's costume to the next one.
 */
Blockly.Blocks['looks_nextcostume'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_NEXTCOSTUME,
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to switch the backdrop to the selected one.
 */
Blockly.Blocks['looks_switchbackdropto'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SWITCHBACKDROPTO,
      args0: [
        {
          type: 'input_value',
          name: 'BACKDROP'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Backdrop list
 */
Blockly.Blocks['looks_backdrops'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: '%1',
      args0: [
        {
          type: 'field_dropdown',
          name: 'BACKDROP',
          options: [
            ['backdrop1', 'BACKDROP1']
          ]
        }
      ],
      extensions: ['colours_looks', 'output_string']
    });
  }
};

/**
 * 'Go to front/back' Block.
 */
Blockly.Blocks['looks_gotofrontback'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_GOTOFRONTBACK,
      args0: [
        {
          type: 'field_dropdown',
          name: 'FRONT_BACK',
          options: [
            [Blockly.Msg.LOOKS_GOTOFRONTBACK_FRONT, 'front'],
            [Blockly.Msg.LOOKS_GOTOFRONTBACK_BACK, 'back']
          ]
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * 'Go forward/backward [Number] Layers' Block.
 */
Blockly.Blocks['looks_goforwardbackwardlayers'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_GOFORWARDBACKWARDLAYERS,
      args0: [
        {
          type: 'field_dropdown',
          name: 'FORWARD_BACKWARD',
          options: [
            [Blockly.Msg.LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD, 'forward'],
            [Blockly.Msg.LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD, 'backward']
          ]
        },
        {
          type: 'input_value',
          name: 'NUM'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to report backdrop's number or name
 */
Blockly.Blocks['looks_backdropnumbername'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_BACKDROPNUMBERNAME,
      args0: [
        {
          type: 'field_dropdown',
          name: 'NUMBER_NAME',
          options: [
            [Blockly.Msg.LOOKS_NUMBERNAME_NUMBER, 'number'],
            [Blockly.Msg.LOOKS_NUMBERNAME_NAME, 'name']
          ]
        }
      ],
      extensions: ['colours_looks', 'output_number', 'monitor_block']
    });
  }
};

/**
 * Block to report costume's number or name
 */
Blockly.Blocks['looks_costumenumbername'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_COSTUMENUMBERNAME,
      args0: [
        {
          type: 'field_dropdown',
          name: 'NUMBER_NAME',
          options: [
            [Blockly.Msg.LOOKS_NUMBERNAME_NUMBER, 'number'],
            [Blockly.Msg.LOOKS_NUMBERNAME_NAME, 'name']
          ]
        }
      ],
      extensions: ['colours_looks', 'output_number', 'monitor_block']
    });
  }
};

/**
 * Block to switch the backdrop to the selected one and wait.
 */
Blockly.Blocks['looks_switchbackdroptoandwait'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_SWITCHBACKDROPTOANDWAIT,
      args0: [
        {
          type: 'input_value',
          name: 'BACKDROP'
        }
      ],
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};

/**
 * Block to switch the backdrop to the next one.
 */
Blockly.Blocks['looks_nextbackdrop'] = {
  init: function(this: Blockly.Block) {
    this.jsonInit({
      message0: Blockly.Msg.LOOKS_NEXTBACKDROP_BLOCK,
      extensions: ['colours_looks', 'shape_statement']
    });
  }
};
